import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import customStyle from "../../Assets/CSS/stylesheet.js";
import Loader from "../Commonscreens/loader.js";

const QuickQuoteReport = () => {
  const [commonModuleURL, setCommonModuleURL] = useState("");
  const [loading, setLoading] = useState(true);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [error, setError] = useState("");

  /** Encrypt Member ID */
  const encryptMemberId = useCallback(async (encodeString) => {
    try {
      const request = { memberId: encodeString };
      const netwellOrganization = Buffer.from(`NETWELL;${new Date()}`).toString(
        "base64"
      );

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}v1/csrportal/idencryption`,
        request,
        {
          headers: {
            "X-Tenant-Id": netwellOrganization,
            Authorization: `Bearer ${localStorage.getItem("NetwellbearerToken")}`,
          },
        }
      );

      if (resp?.data) {
        return encodeURIComponent(resp.data);
      } else {
        throw new Error("Encryption failed");
      }
    } catch (err) {
      console.error("Encryption Error:", err);
      setError("Unable to encrypt member data.");
      return "";
    }
  }, []);

  /** Encrypt Request String */
  const encryptData = useCallback(async (request) => {
    return await encryptMemberId(request);
  }, [encryptMemberId]);

  /** Generate Common Module URL */
  const getCommonModuleURL = useCallback((query) => {
    const token = localStorage.getItem("bearerToken");
    return `${process.env.REACT_APP_SHARED_MODULE_URL}QuickQuote?query=${query}&token=${token}`;
  }, []);

  /** Load Report Data */
  const loadData = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const memberIdSource = localStorage.getItem("sourceid");
      const email = localStorage.getItem("email");
      const type = "";

      const requestString = `memberid=${memberIdSource}&type=${type}&email=${email}`;
      const query = await encryptData(requestString);
      const url = getCommonModuleURL(query);

      setCommonModuleURL(url);
    } catch (err) {
      console.error("Error loading data:", err);
      setError("Failed to load report. Please try again later.");
    } finally {
      setLoading(false);
    }
  }, [encryptData, getCommonModuleURL]);

  /** ComponentDidMount Equivalent */
  useEffect(() => {
    const controller = new AbortController();
    loadData();

    return () => controller.abort();
  }, [loadData]);

  const handleRetry = () => loadData();

  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      {/* Loader */}
      {loading && !error && <Loader />}

      {/* Error */}
      {error && (
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <p style={{ color: "red" }}>{error}</p>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={handleRetry}
          >
            Retry
          </Button>
        </div>
      )}

      {/* Report Iframe */}
      {!loading && !error && (
        <div style={customStyle.HomeContainer}>
          <div style={customStyle.HomeMAinChild}>
            <iframe
              src={commonModuleURL}
              title="Transaction Report"
              onLoad={() => setIframeLoaded(true)}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                margin: "auto",
                opacity: iframeLoaded ? 1 : 0.2,
                transition: "opacity 0.5s ease-in-out",
              }}
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default withStyles(customStyle)(QuickQuoteReport);